/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import styled from "styled-components";

import { BaseBlockContent } from "src/components/Block/styles";

export const StyledLinkBlockContent = styled(BaseBlockContent)`
  overflow: hidden;
`;

export const StyledIframe = styled.iframe<{ disableMouse?: boolean }>`
  width: 100%;
  height: 100%;
  border: 0px;
  pointer-events: ${({ disableMouse }) => (disableMouse ? "none" : "auto")};
`;
